// extracted by mini-css-extract-plugin
module.exports = {"input":"FormInput_input__vUsh3"};